export interface ActionItemsCriteriaData {
  description: string;
  id: number;
}
